/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MetricAudienceSet } from '../models/MetricAudienceSet';
import type { MnpiMetricSearchResult } from '../models/MnpiMetricSearchResult';
import type { MnpiMetricToggle } from '../models/MnpiMetricToggle';
import type { MnpiMetricWithAudience } from '../models/MnpiMetricWithAudience';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MnpiAudiencesService {

    /**
     * List Mnpi Metrics With Audiences
     * List all MNPI metrics with their per-metric audience lists.
     * @returns MnpiMetricWithAudience Successful Response
     * @throws ApiError
     */
    public static listMnpiMetricsWithAudiencesApiV1WorkstreamMnpiMetricsGet(): CancelablePromise<Array<MnpiMetricWithAudience>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/mnpi/metrics',
        });
    }

    /**
     * Search Metrics For Mnpi
     * Search metrics by title for MNPI toggle. Returns all metrics matching query.
     * @param q
     * @returns MnpiMetricSearchResult Successful Response
     * @throws ApiError
     */
    public static searchMetricsForMnpiApiV1WorkstreamMnpiMetricsSearchGet(
        q: string = '',
    ): CancelablePromise<Array<MnpiMetricSearchResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/mnpi/metrics/search',
            query: {
                'q': q,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Toggle Metric Mnpi
     * Toggle a metric's MNPI status on or off.
     * @param metricId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static toggleMetricMnpiApiV1WorkstreamMnpiMetricsMetricIdTogglePost(
        metricId: number,
        requestBody: MnpiMetricToggle,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/mnpi/metrics/{metric_id}/toggle',
            path: {
                'metric_id': metricId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Add To Metric Audience
     * Add employees to a metric's audience.
     * @param metricId
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static addToMetricAudienceApiV1WorkstreamMnpiMetricsMetricIdAudiencePost(
        metricId: number,
        requestBody: MetricAudienceSet,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/mnpi/metrics/{metric_id}/audience',
            path: {
                'metric_id': metricId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Remove From Metric Audience
     * Remove an employee from a metric's audience.
     * @param metricId
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static removeFromMetricAudienceApiV1WorkstreamMnpiMetricsMetricIdAudienceUserIdDelete(
        metricId: number,
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/workstream/mnpi/metrics/{metric_id}/audience/{user_id}',
            path: {
                'metric_id': metricId,
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
